import { Alert } from "@mui/material";
import { COLOR_MESSAGE, COLOR_WHITE } from "helpers/colors";
import { FONT_FAMILY_GRAPHIK } from "helpers/FONT";
import React from "react";

export default function Message({ children, ...others }) {
  return (
    <Alert
      severity="info"
      variant="filled"
      {...others}
      style={{
        ...others.style,
        backgroundColor: others.style?.backgroundColor ?? COLOR_MESSAGE,
        color: others.style?.color ?? COLOR_WHITE,
        fontFamily: FONT_FAMILY_GRAPHIK,
      }}
    >
      {children}
    </Alert>
  );
}
